export default "__VITE_ASSET__P$tkeek8__"